export default "__VITE_ASSET__05a1c74e__"